import { Module } from 'vuex';

import actions from './actions';
import mutations from './mutations';

export const state: Store.Notification.State = {
  notifications: [],
};

const namespaced = true;

export const notification: Module<Store.Notification.State, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
};
